export default "__VITE_ASSET__DwoBKuL0__"